module.exports = __webpack_public_path__ + "static/media/goodnest_app2.efd5b726.jpg";